import Array from './shared/Array.js';
import ArrowFunctionExpression from './ArrowFunctionExpression.js';
import AssignmentExpression from './AssignmentExpression.js';
import BinaryExpression from './BinaryExpression.js';
import CallExpression from './CallExpression.js';
import CatchClause from './CatchClause.js';
import ClassBody from './ClassBody.js';
import ClassDeclaration from './ClassDeclaration.js';
import ClassExpression from './ClassExpression.js';
import ConditionalExpression from './ConditionalExpression.js';
import DoWhileStatement from './DoWhileStatement.js';
import EmptyStatement from './EmptyStatement.js';
import ExpressionStatement from './ExpressionStatement.js';
import ForStatement from './ForStatement.js';
import ForInOfStatement from './shared/ForInOfStatement.js';
import FunctionDeclaration from './FunctionDeclaration.js';
import FunctionExpression from './FunctionExpression.js';
import Identifier from './Identifier.js';
import IfStatement from './IfStatement.js';
import ImportDeclaration from './ImportDeclaration.js';
import ImportDefaultSpecifier from './ImportDefaultSpecifier.js';
import ImportSpecifier from './ImportSpecifier.js';
import LabeledStatement from './LabeledStatement.js';
import Literal from './Literal.js';
import LogicalExpression from './LogicalExpression.js';
import MemberExpression from './MemberExpression.js';
import MethodDefinition from './MethodDefinition.js';
import NewExpression from './NewExpression.js';
import ObjectExpression from './ObjectExpression.js';
import ObjectPattern from './ObjectPattern.js';
import ParenthesizedExpression from './ParenthesizedExpression.js';
import ReturnStatement from './ReturnStatement.js';
import SpreadElement from './SpreadElement.js';
import SwitchCase from './SwitchCase.js';
import SwitchStatement from './SwitchStatement.js';
import TaggedTemplateExpression from './TaggedTemplateExpression.js';
import TemplateLiteral from './TemplateLiteral.js';
import TryStatement from './TryStatement.js';
import UnaryExpression from './UnaryExpression.js';
import UpdateExpression from './UpdateExpression.js';
import VariableDeclaration from './VariableDeclaration.js';
import VariableDeclarator from './VariableDeclarator.js';
import WhileStatement from './WhileStatement.js';
import YieldExpression from './YieldExpression.js';

export default {
	ArrayExpression: Array,
	ArrayPattern: Array,
	ArrowFunctionExpression,
	AssignmentExpression,
	BinaryExpression,
	CallExpression,
	CatchClause,
	ClassBody,
	ClassDeclaration,
	ClassExpression,
	ConditionalExpression,
	DoWhileStatement,
	EmptyStatement,
	ExpressionStatement,
	ForStatement,
	ForInStatement: ForInOfStatement,
	ForOfStatement: ForInOfStatement,
	FunctionDeclaration,
	FunctionExpression,
	Identifier,
	IfStatement,
	ImportDeclaration,
	ImportDefaultSpecifier,
	ImportSpecifier,
	LabeledStatement,
	Literal,
	LogicalExpression,
	MemberExpression,
	MethodDefinition,
	NewExpression,
	ObjectExpression,
	ObjectPattern,
	ParenthesizedExpression,
	ReturnStatement,
	SpreadElement,
	SwitchCase,
	SwitchStatement,
	TaggedTemplateExpression,
	TemplateLiteral,
	TryStatement,
	UnaryExpression,
	UpdateExpression,
	VariableDeclaration,
	VariableDeclarator,
	WhileStatement,
	YieldExpression
};
